import { Selector } from '@ngxs/store';

import { UnitTemplateFilters, UnitTemplatesWithFilters } from '../../models';
import { PROJECT_UNIT_TEMPLATE_STATE_TOKEN, UnitSelectionStateModel } from './unit-template.model';

export class UnitTemplateSelectors {
  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getFilters(state: UnitSelectionStateModel): UnitTemplateFilters {
    return state.filters;
  }

  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getUnitsTemplateWithFilters(state: UnitSelectionStateModel) {
    return state.unitTemplateWithFilters;
  }

  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getUnitsTemplateGroups(state: UnitSelectionStateModel) {
    return state.groups;
  }

  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getSelectedGroups(state: UnitSelectionStateModel) {
    return state.selectedGroup;
  }

  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getHasNextPage(state: UnitSelectionStateModel) {
    return state.unitTemplateWithFilters.list.length < state.pagination.total;
  }

  @Selector([PROJECT_UNIT_TEMPLATE_STATE_TOKEN])
  static getIsLoadingMore(state: UnitSelectionStateModel) {
    return state.isLoadingMore;
  }

  @Selector([UnitTemplateSelectors.getUnitsTemplateWithFilters])
  static getUnitsTemplate(state: UnitTemplatesWithFilters) {
    return state ? state.list : [];
  }

  @Selector([UnitTemplateSelectors.getUnitsTemplateWithFilters])
  static getUnitsTemplateFilters(state: UnitTemplatesWithFilters) {
    return state ? state.filters : [];
  }
}
